var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M5 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm7 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm7 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }